var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBriefcase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M32 28H4v-6.68a7.1 7.1 0 0 1-2-1.43V28a2 2 0 0 0 2 2h28a2 2 0 0 0 2-2v-8.11a6.7 6.7 0 0 1-2 1.42Z",
    className: "clr-i-outline clr-i-outline-path-1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M25 22.4a1 1 0 0 0 1-1v-5.46h-2V18H14v2h10v1.4a1 1 0 0 0 1 1",
    className: "clr-i-outline clr-i-outline-path-2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M33 6h-9V4.38A2.42 2.42 0 0 0 21.55 2h-7.1A2.42 2.42 0 0 0 12 4.38V6H3a1 1 0 0 0-1 1v8a5 5 0 0 0 5 5h3v1.4a1 1 0 0 0 2 0v-5.46h-2V18H7a3 3 0 0 1-3-3V8h28v7a3 3 0 0 1-3 3h-1v2h1a5 5 0 0 0 5-5V7a1 1 0 0 0-1-1M22 6h-8V4.43a.45.45 0 0 1 .45-.43h7.11a.43.43 0 0 1 .44.42Z",
    className: "clr-i-outline clr-i-outline-path-3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h36v36H0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBriefcase);
export default __webpack_public_path__ + "static/media/briefcase.ada492bd8a28e835f01905ee849a9015.svg";
export { ForwardRef as ReactComponent };